
import { MessageApi, MessageRequestTableDto } from 'generated/apiMessages';
import { Configuration } from 'generated/configuration';
import { getLoggedinUser } from 'helpers/api_helper';

const { REACT_APP_API_URL } = process.env;

export const fetchMessages = {
  queryFn: async (data: MessageRequestTableDto) => {
    const authUser: any = getLoggedinUser();

    const api = new MessageApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.messageControllerFind(data);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchMessages", { ...data }],
};


export const fetchMessagesNoRead = {
  queryFn: async (id: string) => {
    const authUser: any = getLoggedinUser();

    const api = new MessageApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.messageControllerFindNoRead(authUser.uid);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchMessagesNoRead"],
};



